import { render } from "./paymentExplanation.html?vue&type=template&id=6149d124&scoped=true&ts=true&external"
import script from "./PaymentExplanation.vue?vue&type=script&lang=ts"
export * from "./PaymentExplanation.vue?vue&type=script&lang=ts"

import "./PaymentExplanation.vue?vue&type=style&index=0&id=6149d124&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6149d124"]])

export default __exports__